class BESSAppProjectDependencyHandler extends BESSAppBase {

    constructor() {
        super();
    }

    handle(event) {
        //this.log("handle", event);
    }
}